module.exports = __webpack_public_path__ + "img/sunset.3bae4a5b.jpg";